var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { array, fragmentArray } from 'ember-data-model-fragments/attributes';
import { attr } from '@ember-data/model';
let ComboSlot = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number', {
  defaultValue: 1
}), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = array(), _dec8 = array(), _dec9 = fragmentArray('connect/item/combo-type-details/price-adjustments'), _class = class ComboSlot extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "uid", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    // The number of selections in order to fulfill this slot
    _initializerDefineProperty(this, "numSelections", _descriptor3, this);
    // (Optional) Default item variation of this slot
    _initializerDefineProperty(this, "defaultItemVariationId", _descriptor4, this);
    // The item for this slot. Any variation of the item can fulfill this slot.
    _initializerDefineProperty(this, "itemId", _descriptor5, this);
    // The category for this slot. Any item variation in this category (or a sub-category)
    // can fulfill this slot.
    _initializerDefineProperty(this, "categoryId", _descriptor6, this);
    _initializerDefineProperty(this, "itemIds", _descriptor7, this);
    _initializerDefineProperty(this, "itemVariationIds", _descriptor8, this);
    _initializerDefineProperty(this, "priceAdjustments", _descriptor9, this);
  }
  static catalogType() {
    return 'COMBO_SLOT';
  }
  get item() {
    return this.store.peekRecord('connect/item', this.itemId);
  }
  get menuCategory() {
    return this.store.peekRecord('connect/category', this.categoryId);
  }
  get defaultItemVariation() {
    return this.store.peekRecord('connect/item-variation', this.defaultItemVariationId);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "uid", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "numSelections", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "defaultItemVariationId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "itemId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "categoryId", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "itemIds", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "itemVariationIds", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "priceAdjustments", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ComboSlot as default };